'use client';

import { useOnboardingRedirect } from '@/hooks/use-onboarding-redirect';

export function LocalePageClient() {
  // The redirect hook owns the loading state and onboarding flow.
  // The parent server component provides SSR metadata for SEO.
  const { component } = useOnboardingRedirect();
  return component;
}
